/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareLeftIcon16Solid = forwardRef('ArrowFigureASquareLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 1A3.5 3.5 0 0 1 15 4.5v7a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 1 11.5v-7A3.5 3.5 0 0 1 4.5 1h7ZM8.055 4.55a.75.75 0 0 1-.061 1.058L6.15 7.25h5.616a.75.75 0 0 1 0 1.5H6.15l1.844 1.642a.75.75 0 0 1-.998 1.12L4.52 9.307a1.75 1.75 0 0 1 0-2.614l2.476-2.205a.75.75 0 0 1 1.059.061Z" })));
});
